import React from "react";
import { Modal, Tooltip } from "antd";
import Logger from "@/utility/logger";

function SectionGeneratorHeader({
  sectionStatus,
  section,
  generatedSections,
  sectionGeneration,
  setSelectedSections,
  sections,
  selectedSections,
  setIsSpecialSectionGenerating,
  scrollToSection,
}) {
  const isGeneratedSection = generatedSections.some((s) => s.id === section.id);
  const isSelectedSection = selectedSections.some((s) => s.id === section.id);
  const isSelectedOrGenerated = isSelectedSection || isGeneratedSection;

  return (
    <>
      <label
        className={`section_generator_panel_selectall_container ${
          isGeneratedSection ? "generated" : "with_overlay_action"
        }`}
        style={{}}
      >
        <div
          onClick={() => {
            const isDisabled =
              sectionStatus[section.id] === false ||
              isGeneratedSection ||
              section.user_query === "" ||
              sectionGeneration;
            if (isDisabled) return;

            const proceedToSelect = () => {
              setSelectedSections((prev) => {
                const exists = prev.some((s) => s.id === section.id);
                return exists ? prev.filter((s) => s.id !== section.id) : [...prev, section];
              });
            };

            const includeCurrentDocument =
              section.display_name.toLowerCase().includes("executive summary") ||
              section.display_name.toLowerCase().includes("abbreviation");

            Logger.debug("SectionGeneratorHeader.tsx: Check current document inclusion", includeCurrentDocument);

            const allDisplayableSections = sections.filter(
              (s) => s.type.toLowerCase() === "section" || s.type.toLowerCase() === "section_agentic"
            );
            const generatedSectionIds = generatedSections.map((s) => s.id);

            const hasUngeneratedSections = allDisplayableSections.some(
              (s) =>
                s.id !== section.id &&
                !generatedSectionIds.includes(s.id) &&
                !s.display_name.toLowerCase().includes("executive summary") &&
                !s.display_name.toLowerCase().includes("abbreviation")
            );

            const isAlreadySelected = selectedSections.some((s) => s.id === section.id);

            if (includeCurrentDocument && hasUngeneratedSections && !isAlreadySelected) {
              Modal.confirm({
                title: "Summary generation",
                icon: null,
                content:
                  "This section will process content from other sections of the document.  Please ensure all sections are generated. Would you like to continue?",

                async onOk() {
                  proceedToSelect();
                  setIsSpecialSectionGenerating(true);
                },
                onCancel() {
                  Logger.debug("SectionGeneratorHeader.tsx: User clicked cancel, do nothing.");
                },
                okText: "Continue",
              });
            } else {
              setIsSpecialSectionGenerating(false);
              proceedToSelect();
            }
          }}
          className="section_generator_panel_selectall_back"
          style={{
            backgroundColor:
              sectionStatus[section.id] === false
                ? "#e0e0e0"
                : isSelectedSection
                ? "var(--primary-color)"
                : "#ccc",
            cursor:
              sectionStatus[section.id] === false ||
              isGeneratedSection ||
              section.user_query === "" ||
              sectionGeneration
                ? "not-allowed"
                : "pointer",
            opacity: sectionStatus[section.id] === false ? 0.6 : 1,
          }}
        >
          <div
            className="section_generator_panel_selectall_front"
            style={{
              left: isSelectedOrGenerated ? "18px" : "2px",
            }}
          />
        </div>

        <Tooltip title={`${section.display_name}`}>
          <span
            className={`section_generator_panel_item_label ${isGeneratedSection ? "generated" : ""}`}
            style={{
              color: sectionStatus[section.id] === false ? "#8f8f8f" : "#333",
              cursor: "pointer",
            }}
            onClick={() => {
              scrollToSection(`${section.insertion_key}`);
            }}
          >
            {section.display_name}
          </span>
        </Tooltip>
      </label>
    </>
  );
}

export default SectionGeneratorHeader;
